<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <button
                    type="button"
                    @click="showPage(0)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 0 ? 'active' : '',
                    ]"
                >
                    &nbsp;Banner Home
                </button>
                <button
                    type="button"
                    @click="showPage(1)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 1 ? 'active' : '',
                    ]"
                >
                    &nbsp;Home Categorias
                </button>
                <button
                    type="button"
                    @click="showPage(2)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 2 ? 'active' : '',
                    ]"
                >
                    &nbsp;Home Ganadores
                </button>
                <button
                    type="button"
                    @click="showPage(3)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 3 ? 'active' : '',
                    ]"
                >
                    &nbsp; ¿Qué es?
                </button>
                <button
                    type="button"
                    @click="showPage(4)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 4 ? 'active' : '',
                    ]"
                >
                    &nbsp;Finalistas
                </button>
                <button
                    type="button"
                    @click="showPage(5)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 5 ? 'active' : '',
                    ]"
                >
                    &nbsp;Home SEO
                </button>
                <button
                    type="button"
                    @click="showPage(6)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 6 ? 'active' : '',
                    ]"
                >
                    &nbsp;Que es SEO
                </button>
                <button
                    type="button"
                    @click="showPage(7)"
                    :class="[
                        'btn btn-outline-primary',
                        page == 7 ? 'active' : '',
                    ]"
                >
                    &nbsp;Finalistas SEO
                </button>
            </div>

            <div>
                <contest-home-banner-component
                    v-if="page == 0"
                    v-bind:model_id="model_id"
                ></contest-home-banner-component>
                <contest-home-category-component
                    v-if="page == 1"
                    v-bind:model_id="model_id"
                ></contest-home-category-component>
                <contest-winner-component
                    v-if="page == 2"
                    v-bind:model_id="model_id"
                ></contest-winner-component>
                <contest-what-component
                    v-if="page == 3"
                    v-bind:model_id="model_id"
                ></contest-what-component>
                <contest-finalist-component
                    v-if="page == 4"
                    v-bind:model_id="model_id"
                ></contest-finalist-component>
                <seo-component
                    v-if="page == 5"
                    v-bind:url="'/admin/seo/home'"
                    v-bind:parent_id="model_id"
                    key="1"
                ></seo-component>
                <seo-component
                    v-if="page == 6"
                    v-bind:url="'/admin/seo/concepto'"
                    v-bind:parent_id="model_id"
                    key="2"
                ></seo-component>
                <seo-component
                    v-if="page == 7"
                    v-bind:url="'/admin/seo/finalistas'"
                    v-bind:parent_id="model_id"
                    key="3"
                ></seo-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
        };
    },
    methods: {
        showPage(value) {
            this.page = value;
        },
    },
    mounted() {},
};
</script>
